<template>
  <div class="setting_content">
    <ConfirmDeleteCategory
        v-show="isVisibleModalConfirmDelete"
        @close="closeModalConfirmDelete"
        @delete="confirmDeleteCategory"
    />
    <ConfirmDeleteItem
        v-show="isVisibleModalConfirmDeleteItem"
        @close="closeModalConfirmDeleteItem"
        @delete="confirmDeleteItem(categoryIndex, itemIndex)"
    />
    <div class="setting_content_main">
      <div class="setting_content_heading">
        <h2 class="setting_content_title">
          {{ screenLabelsProperties.TAB_HEADER }}
        </h2>
        <div class="setting_content_heading_btn ml-3">
          <button class="setting_btn_secondary setting_btn_medium"
                  @click="openPopupAddCategory">
            {{ screenLabelsProperties.ADD_CATEGORY_BUTTON }}
          </button>
          <ModalCategory
              v-show="isVisibleModalCategory"
              :category="category"
              @close="closeModalCategory"
              @submit="addCategory()"
          />
        </div>
      </div>
      <div class="setting_category_header">
        <div class="setting_category_header_sorting">
          {{ screenLabelsProperties.SORT_FIELD }}
        </div>
        <div class="setting_category_header_display">
          {{ screenLabelsProperties.DISPLAY_FIELD }}
        </div>
        <div class="setting_category_header_content">
          {{ screenLabelsProperties.ITEM_NAME_FIELD }}
        </div>
        <div class="setting_category_header_operation_wide">
          {{ screenLabelsProperties.OPTION_FIELD }}
        </div>
      </div>
      <draggable
          :list="categories"
          handle=".handle"
          v-bind="{ disabled: false }"
          @change="updateDisplay"
          @sort="updateCategory"
          class="setting_category"
      >
        <div class="setting_category_wrapper" v-for="(subCategory, index) in categories" :key="index">
          <div class="setting_category_item" v-if="subCategory && !subCategory.categoryDeleted">
            <div class="setting_category_item_sorting">
              <svg class="setting_category_item_sorting_icon handle evt-click"
                   width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                <g fill="#aaa" fill-rule="evenodd">
                  <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"/>
                </g>
              </svg>
            </div>
            <div class="setting_category_item_display">
              <div class="setting_category_item_display_arrow evt-click" v-if="!subCategory.isCollapse"
                   @click.prevent="changeCollapse(index)">
                <svg width="6" height="6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 0l3 6H0z" fill="#333" fill-rule="evenodd"/>
                </svg>
              </div>
              <div class="setting_category_item_display_arrow is_open evt-click" v-else
                   @click.prevent="changeCollapse(index)">
                <svg width="6" height="6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 0l3 6H0z" fill="#333" fill-rule="evenodd"/>
                </svg>
              </div>
            </div>
            <div class="setting_category_item_content setting_word_break">
              {{ subCategory.categoryName }}
            </div>
            <div class="setting_category_item_operation">
              <div class="setting_category_item_operation_add">
                <a class="setting_category_item_operation_add_btn" @click="openAddItemModal(index, -1)">
                  {{ screenLabelsProperties.ADD_ITEM_LINK }}
                </a>
                <AddItem
                    v-if="isVisibleModalItems[index] && isVisibleModalItems[index].status"
                    :item="item"
                    :availableResource="availableResource"
                    :resourceFields="resourceFields"
                    @updateResourceFields="updateResourceFields"
                    @close="closeAddItemModal(index, -1)"
                    @submit="addItemToCategory(categoryIndex, itemIndex)"
                    @updateFirstResourceCategory="updateFirstResourceCategory"
                    @resetFirstResourceCategory="resetFirstResourceCategory(index)"
                />
              </div>
              <div class="setting_category_item_operation_edit">
                <button class="setting_btn_secondary setting_btn_medium" @click="openPopUpEditCategory(index)">
                  {{ screenLabelsProperties.EDIT_ITEM_BUTTON }}
                </button>
                <ModalCategory
                    v-show="isVisibleEditModalCategories[index]"
                    :category="category"
                    @close="closeModalEditCategory(index)"
                    @submit="editCategory(index)"
                />
              </div>
              <button class="setting_btn_delete setting_btn_medium" @click="deleteCategory(index)">
                {{ screenLabelsProperties.DELETE_ITEM_BUTTON }}
              </button>
            </div>
          </div>
          <div v-if="subCategory && !subCategory.categoryDeleted">
            <draggable
                v-if="subCategory.isCollapse"
                :list="subCategory.item"
                handle=".handle"
                @change="logChangeData"
                @sort="updateCategory"
            >
              <div class="align-items-center" v-for="(resource, subIndex) in subCategory.item" :key="subIndex">
                <template v-if="resource.itemDeleted === undefined || !resource.itemDeleted">
                  <div class="setting_column_item" :class="resource.isDeletedByMainSystem ? 'item-deleted-setting' : ''"
                       :title="resource.isDeletedByMainSystem ? screenMessagesProperties.ITEM_DELETED_BY_MATCHINGGOOD2ND : ''">
                    <div class="setting_column_item_sorting handle evt-click">
                      <svg
                          class="setting_column_item_sorting_icon"
                          width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#aaa" fill-rule="evenodd">
                          <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"/>
                        </g>
                      </svg>
                    </div>
                    <div class="setting_column_item_content setting_word_break">
                      {{ resource.itemName }}
                    </div>
                    <div class="setting_column_item_operation">
                      <div class="setting_column_item_operation_add">
                        <button class="setting_btn_secondary setting_btn_medium"
                                @click="openAddItemModal(index, subIndex)">
                          {{ screenLabelsProperties.EDIT_ITEM_BUTTON }}
                        </button>
                        <AddItem
                            v-show="isVisibleModalItems[index] && isVisibleModalItems[index].subModal[subIndex]"
                            :item="item"
                            :availableResource="availableResource"
                            :resourceFields="resourceFields"
                            @updateResourceFields="updateResourceFields"
                            @close="closeAddItemModal(index, subIndex)"
                            @submit="addItemToCategory(categoryIndex, itemIndex)"
                            @updateFirstResourceCategory="updateFirstResourceCategory"
                            @resetFirstResourceCategory="resetFirstResourceCategory(index)"
                            ref="addItemRef"
                        />
                      </div>
                      <button class="setting_btn_delete setting_btn_medium" @click="deleteItem(index, subIndex)">
                        {{ screenLabelsProperties.DELETE_ITEM_BUTTON }}
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </draggable>
          </div>
        </div>
      </draggable>
    </div>
    <div>
      <div class="setting_content_sub" id="menu-search-item-screen-tab">
        <div id="heading_search_item">
          <div class="setting_options_search d-flex justify-content-end">
            <button class="setting_btn_secondary setting_btn_medium" @click="refreshResourceList">
              {{ screenLabelsProperties.REFRESH_RESOURCE_BUTTON }}
            </button>
          </div>
          <div class="setting_options_search setting_options_search_customize">
            <p class="setting_options_search_label">
              {{ screenLabelsProperties.SEARCH_LABEL }}
            </p>
            <div class="setting_options_search_box">
              <input
                  class="setting_form_text"
                  type="text"
                  :placeholder="[[screenLabelsProperties.SEARCH_PLACEHOLDER]]"
                  v-model="computedProperty"
                  v-on:keyup.enter="getResourceFields"
              />
              <button class="setting_btn_primary" v-on:click="getResourceFields">
                <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none" fill-rule="evenodd">
                    <circle stroke="#FFF" stroke-width="2" cx="6.5" cy="6.5" r="5.5"/>
                    <path fill="#FFF" d="M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"/>
                  </g>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="setting_options_wrapper" id="item_resource_wrapper">
          <div class="setting_options_category">
            <div v-for="(candidateCategory, index) in candidateCategories" :key="index">
              <template v-if="checkEmptyResourceCategory(candidateCategory.name) && candidateCategory.is_display === 1">
                <p class="setting_options_category_name candidates mt-3">
                  {{ candidateCategory.display_name }}
                </p>
                <draggable
                    :group="{ name: 'item-category', put: false, pull: 'clone' }"
                    :sort="false"
                    :clone="cloneResource"
                    :list="computedResourceFields"
                >
                  <div v-for="(resourceField, index) in computedResourceFields" :key="index">
                    <div @mousedown="checkAvailableResourceDragging(resourceField.property_category_name)"
                         v-if="resourceField.property_category_name === candidateCategory.name && !resourceField.isUsed"
                         class="setting_options_category_item"
                         :class="resourceField && resourceField.required === 1 ? 'item_required' : ''"
                         :title="resourceField && resourceField.required === 1 ? resourceField.display_name + screenMessagesProperties.ITEM_REQUIRE_SETTING : ''"
                    >
                      <svg class="setting_options_category_item_icon"
                           width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#aaa" fill-rule="evenodd">
                          <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"/>
                        </g>
                      </svg>
                      <span class="setting_options_category_item_name" v-text="resourceField.display_name"></span>
                    </div>
                  </div>
                </draggable>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import draggable from "vuedraggable";
import ModalCategory from "./ModalComponents/AddCategoryModal.vue";
import AddItem from "./ModalComponents/AddItemModal.vue";
import ConfirmDeleteCategory from "./ModalComponents/ConfirmDeleteCategoryModal.vue";
import ConfirmDeleteItem from "./ModalComponents/ConfirmDeleteItemModal";
import screenLabelsProperties from "../../../properties/entry_screen/screen_tab/screen-labels.json";
import screenMessagesProperties from "../../../properties/entry_screen/screen_tab/screen-messages.json";
import screenMaxlengthProperties from "../../../properties/entry_screen/screen_tab/screen-maxlength.json";
import VueToast from "vue-toast-notification";
import * as generalLabels from "../../../properties/general_page/generalpage-labels.json";
import * as entrySettingLabels from "../../../properties/entry_screen/entry_screen.json";
import generalService from "../../../services/GeneralService";

Vue.use(VueToast);

export default {
  name: "ScreenTab",
  props: [
    "categories",
    "groupName",
    "candidateCategories",
    "resourceFields",
    "property",
    "userId",
    "navTab"
  ],
  components: {
    draggable,
    ModalCategory,
    AddItem,
    ConfirmDeleteCategory,
    ConfirmDeleteItem,
  },
  watch: {
    navTab() {
      this.closeAllModal();
    },
  },
  data: function () {
    return {
      item: {
        itemName: "",
        annotationText: "",
        itemRequired: false,
        viewAnnotation: false,
        resourceField: [[]],
        deletedResource: [],
      },
      category: {
        categoryName: "",
        categoryDeleted: false,
        categoryDisplay: -1,
        item: [],
      },
      isVisibleModalCategory: false,
      isVisibleModalConfirmDelete: false,
      isVisibleModalAddItem: false,
      isVisibleModalConfirmDeleteItem: false,
      indexCategoryRemove: -1,
      isLoading: false,
      categoryIndex: -1,
      itemIndex: -1,
      option: 0,
      categoryIndexDelete: 0,
      itemIndexDelete: 0,
      screenLabelsProperties: screenLabelsProperties,
      screenMessagesProperties: screenMessagesProperties,
      screenMaxlengthProperties: screenMaxlengthProperties,
      isVisibleEditModalCategories: [],
      isVisibleModalItems: [],
      availableResource: true,
      firstResourceCategory: "",
      log: {
        info: {},
      },
    };
  },
  computed: {
    computedProperty: {
      get() {
        return this.property;
      },
      set(val) {
        this.$emit("updatedProperty", val);
      },
    },
    computedResourceFields: {
      get() {
        return this.resourceFields;
      },
      set(val) {
        this.$emit("updateResourceField", val);
      },
    },
  },
  methods: {
    async getResourceFields() {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Click tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Search " + screenLabelsProperties.SEARCH_LABEL;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.$emit("getResourceFields", this.log.hash);
    },

    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },

    async addItemToCategory(categoryIndex, itemIndex) {
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.SAVE_ITEM;
      await this.$emit("sendLogger", this.log);

      let idItem = "";
      if (this.categories[categoryIndex] && this.categories[categoryIndex].item[itemIndex]) {
        idItem = this.categories[categoryIndex].item[itemIndex].id;
      }

      this.handleOutputItem(this.item, categoryIndex, itemIndex, idItem);
      this.$eventBus.$emit("unSaved", true);
      this.refreshItem();
      if (itemIndex === -1) {
        this.isVisibleModalItems[categoryIndex].status = false;
      } else {
        this.isVisibleModalItems[categoryIndex].subModal[itemIndex] = false;
      }
      this.firstResourceCategory = "";

      this.$emit("updateEditingStatus", false);
    },

    checkItemLength(index) {
      let length = 0;
      this.item.resourceField[index].forEach(i => {
        if (i.itemResourceDeleted === undefined || !i.itemResourceDeleted) {
          length++;
        }
      });

      return length;
    },

    async addCategory() {
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.SAVE_CATEGORY_BUTTON;
      await this.$emit("sendLogger", this.log);
      if (this.validateInputCategory(this.category)) {
        let newCategory = {
          categoryName: this.category.categoryName,
          categoryDeleted: false,
          categoryDisplay: -1,
          item: [],
          isCollapse: false
        };

        this.categories.push(JSON.parse(JSON.stringify(newCategory)));
        this.isVisibleEditModalCategories.fill(false);
        this.updateDisplay();
        this.refreshCategory();
        this.$eventBus.$emit("unSaved", true);
        this.isVisibleModalCategory = false;
        this.$emit("updateEditingStatus", false);
      }
    },

    validateInputCategory(category) {
      if (!category.categoryName || category.categoryName === "" || category.categoryName.trim() === "") {
        this.handleWarningMessage(screenMessagesProperties.EMPTY_CATEGORY_NAME);
        return false;
      }

      if (category.categoryName && category.categoryName.trim().length > screenMaxlengthProperties.MAX_LENGTH_CATEGORY_NAME) {
        this.handleWarningMessage(screenMaxlengthProperties.MAX_LENGTH_CATEGORY_NAME + screenMessagesProperties.OVERLENGTH_CATEGORY_NAME);
        return false;
      }

      return true;
    },

    handleWarningMessage(message) {
      Vue.$toast.clear();
      Vue.$toast.warning(message, {
        position: "bottom-right",
        duration: 3000,
      });
    },

    refreshCategory() {
      this.category = {
        categoryName: "",
        categoryDeleted: false,
        categoryDisplay: -1,
        item: [],
      };
    },

    async openPopUpEditCategory(index) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.EDIT_ITEM_BUTTON;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.refreshCategory();
      this.category = JSON.parse(JSON.stringify(this.categories[index]));
      this.closeAllModal();
      this.isVisibleEditModalCategories[index] = true;
      this.$emit("updateEditingStatus", true);
    },

    async closeModalEditCategory(index) {
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.CLOSE_MODAL;
      await this.$emit("sendLogger", this.log);
      this.refreshCategory();
      this.isVisibleEditModalCategories[index] = false;
      this.$emit("updateEditingStatus", false);
    },

    async openPopupAddCategory() {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.ADD_CATEGORY_BUTTON;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.category = {};
      this.closeAllModal();
      this.isVisibleModalCategory = true;
      this.$emit("updateEditingStatus", true);
    },

    async closeModalCategory() {
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.CLOSE_MODAL;
      await this.$emit("sendLogger", this.log);
      this.isVisibleModalCategory = false;
      this.$emit("updateEditingStatus", false);
    },

    async closeModalConfirmDelete() {
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Popup Confirm Delete Category - Click button " + screenLabelsProperties.CLOSE_MODAL;
      await this.$emit("sendLogger", this.log);
      this.isVisibleModalConfirmDelete = false;
      this.$emit("updateEditingStatus", false);
    },

    async closeModalConfirmDeleteItem() {
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Popup Confirm Delete Item - Click button " + screenLabelsProperties.CLOSE_MODAL;
      await this.$emit("sendLogger", this.log);
      this.isVisibleModalConfirmDeleteItem = false;
      this.$emit("updateEditingStatus", false);
    },

    async openAddItemModal(categoryIndex, itemIndex) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      if (itemIndex === -1) {
        this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click " + screenLabelsProperties.ADD_ITEM_LINK;
      } else {
        this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.EDIT_ITEM_BUTTON;
      }

      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.categoryIndex = categoryIndex;
      this.itemIndex = itemIndex;
      this.setFirstResourceCategory(categoryIndex);
      if (!this.isVisibleModalItems[categoryIndex]) {
        this.isVisibleModalItems[categoryIndex] = {
          status: false,
          subModal: []
        }
      }

      this.closeAllModal();
      if (itemIndex !== -1) {
        this.item = this.handleInputItem(this.categories[categoryIndex].item[itemIndex]);
        this.isVisibleModalItems[categoryIndex].subModal[itemIndex] = true;
        this.isVisibleModalItems = JSON.parse(JSON.stringify(this.isVisibleModalItems));
        this.$refs.addItemRef[itemIndex].checkItemSettingHasResourceRequired(this.item);
      } else {
        this.isVisibleModalItems[categoryIndex].status = true;
        this.isVisibleModalItems = JSON.parse(JSON.stringify(this.isVisibleModalItems));
      }

      this.$emit("updateEditingStatus", true);
    },

    setFirstResourceCategory(categoryIndex) {
      if (this.checkCategoryItemsLength(categoryIndex) === 0) {
        this.firstResourceCategory = "";
      } else {
        for (let i = 0; i < this.categories[categoryIndex].item.length; i++) {
          if (this.categories[categoryIndex].item[i].itemDeleted) {
            continue;
          }

          let firstResourceName = this.categories[categoryIndex].item[i].resourceField.find(resource => resource.itemDisplayOrder === 0 && resource.itemColumn === 0).name;
          if (firstResourceName.includes("educations.")) {
            this.firstResourceCategory = "educations";
            break;
          }

          if (firstResourceName.includes("careers.")) {
            this.firstResourceCategory = "careers";
            break;
          }

          this.firstResourceCategory = "other";
        }
      }
    },

    async closeAddItemModal(index, itemIndex) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.CLOSE_MODAL;
      await this.$emit("sendLogger", this.log);
      this.refreshItem();
      if (itemIndex === -1) {
        this.isVisibleModalItems[index].status = false;
      } else {
        this.isVisibleModalItems[index].subModal[itemIndex] = false;
      }
      this.firstResourceCategory = "";
      this.$emit("getResourceFields", this.log.hash);
      this.$emit("updateEditingStatus", false);
    },

    async editCategory(index) {
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.SAVE_CATEGORY_BUTTON;
      await this.$emit("sendLogger", this.log);
      if (this.validateInputCategory(this.category)) {
        this.categories[index] = JSON.parse(JSON.stringify(this.category));
        this.$eventBus.$emit("unSaved", true);
        this.updateCategory();
        await this.closeModalEditCategory(index);
      }
      this.$emit("updateEditingStatus", false);
    },

    async deleteCategory(index) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.DELETE_ITEM_BUTTON;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.closeAllModal();
      this.isVisibleModalConfirmDelete = true;
      this.indexCategoryRemove = index;
      this.$emit("updateEditingStatus", true);
    },

    async deleteItem(categoryIndex, itemIndex) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.DELETE_ITEM_BUTTON;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.categoryIndexDelete = categoryIndex;
      this.itemIndexDelete = itemIndex;
      this.closeAllModal();
      this.isVisibleModalConfirmDeleteItem = true;
      this.$emit("updateEditingStatus", true);
    },

    async confirmDeleteCategory() {
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Popup Confirm Delete Category - Click button " + screenLabelsProperties.CONFIRM_DELETE_BUTTON;
      await this.$emit("sendLogger", this.log);
      this.categories[this.indexCategoryRemove].categoryDeleted = true;
      this.updateDisplay();
      this.isVisibleModalConfirmDelete = false;
      this.$eventBus.$emit("unSaved", true);
      this.updateCategory();
      await this.$emit("getResourceFields", this.log.hash);
      this.$emit("updateEditingStatus", false);
    },

    async confirmDeleteItem() {
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Popup Confirm Delete Item - Click button " + screenLabelsProperties.CONFIRM_DELETE_BUTTON;
      await this.$emit("sendLogger", this.log);
      this.categories[this.categoryIndexDelete].item[this.itemIndexDelete].itemDeleted = true;
      this.isVisibleModalConfirmDeleteItem = false;
      this.$eventBus.$emit("unSaved", true);
      this.updateCategory();
      this.$emit("getResourceFields", this.log.hash);
      this.$emit("updateEditingStatus", false);
    },

    changeCollapse(index) {
      if (!this.categories || !this.categories[index].item || this.checkCategoryItemsLength(index) === 0) {
        return;
      }

      this.categories[index].isCollapse = !this.categories[index].isCollapse;
      this.updateCategory();
    },

    checkCategoryItemsLength(index) {
      let length = 0;
      this.categories[index].item.forEach((i) => {
        if (i.itemDeleted === undefined || i.itemDeleted === false) {
          length++;
        }
      });

      return length;
    },

    refreshItem() {
      this.item = {
        itemRequired: false,
        viewAnnotation: false,
        annotationText: "",
        itemName: "",
        resourceField: [[]],
        deletedResource: [],
      };
    },

    handleInputItem(item) {
      let newItem = {
        id: item && item.id ? item.id : null,
        itemName: item && item.itemName ? item.itemName : "",
        annotationText: item && item.annotationText ? item.annotationText : "",
        itemRequired: item && item.itemRequired ? item.itemRequired : false,
        viewAnnotation: item && item.viewAnnotation ? item.viewAnnotation : false,
        resourceField: item && item.resourceField ? item.resourceField : [[]],
        deletedResource: [],
      };

      let resource = [[]];
      for (let i = 0; i < item.resourceField.length; i++) {
        if (item.resourceField[i].itemResourceDeleted === undefined || !item.resourceField[i].itemResourceDeleted) {
          let row = item.resourceField[i].itemDisplayOrder;
          let col = item.resourceField[i].itemColumn;
          if (!resource[row]) {
            resource[row] = [];
          }

          if (!resource[row][col]) {
            resource[row][col] = [];
          }

          resource[row][col] = JSON.parse(JSON.stringify(item.resourceField[i]));
        } else {
          newItem.deletedResource.push(JSON.parse(JSON.stringify(item.resourceField[i])));
        }
      }

      newItem.resourceField = resource;
      this.updateCategory();
      return newItem;
    },

    handleOutputItem(oldItem, categoryIndex, itemIndex, idItem) {
      let newItem = {
        id: idItem ? idItem : null,
        itemName: oldItem && oldItem.itemName ? oldItem.itemName : "",
        annotationText: oldItem && oldItem.annotationText ? oldItem.annotationText : "",
        itemRequired: oldItem && oldItem.itemRequired ? oldItem.itemRequired : false,
        viewAnnotation: oldItem && oldItem.viewAnnotation ? oldItem.viewAnnotation : false,
        resourceField: [],
      };

      let resource = [];
      let row = 0;
      let col = 0;
      for (let i = 0; i < oldItem.resourceField.length; i++) {
        col = 0;
        let existResource = false;
        for (let j = 0; j < oldItem.resourceField[i].length; j++) {
          if (oldItem.resourceField[i][j].display_name === "") {
            continue;
          }

          let subItem = JSON.parse(JSON.stringify(oldItem.resourceField[i][j]));
          if (oldItem.resourceField[i][j].itemResourceDeleted !== undefined && oldItem.resourceField[i][j].itemResourceDeleted) {
            subItem.itemDisplayOrder = -1;
            subItem.itemColumn = -1;
          } else {
            existResource = true;
            subItem.itemDisplayOrder = row;
            subItem.itemColumn = col;
            col++;
          }

          resource.push(subItem);
        }

        if (existResource) {
          row++;
        }
      }

      oldItem.deletedResource.forEach(res => resource.push(JSON.parse(JSON.stringify(res))));
      newItem.resourceField = resource;
      if (this.itemIndex === -1) {
        this.categories[categoryIndex].item.push(newItem);
      } else {
        this.categories[categoryIndex].item[itemIndex] = newItem;
      }

      this.categories[categoryIndex].isCollapse = true;
      this.updateCategory();
    },

    updateDisplay() {
      let index = 0;
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].categoryDeleted) {
          continue;
        }

        this.categories[i].categoryDisplay = index++;
      }

      this.$eventBus.$emit("unSaved", true);
    },

    async refreshResourceList() {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = "Menu " + generalLabels.SECOND_TAB + " - Tab " + entrySettingLabels.SCREEN_TAB_TITLE + " - Click button " + screenLabelsProperties.REFRESH_RESOURCE_BUTTON;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
      this.$emit("refreshResourceList", this.log.hash);
    },

    checkAvailableResourceDragging(propertyName) {
      let result = false;
      if (this.firstResourceCategory === "") {
        result = true;
      } else {
        if (propertyName === "careers" || propertyName === "educations") {
          result = this.firstResourceCategory === propertyName;
        } else {
          if (this.firstResourceCategory === "other") {
            result = true;
          }
        }
      }

      this.availableResource = result;
    },

    updateFirstResourceCategory(val) {
      this.firstResourceCategory = val;
    },

    updateResourceFields(resourceFields) {
      this.$emit("updateResourceField", [...resourceFields]);
    },

    resetFirstResourceCategory(index) {
      if (this.checkCategoryItemsLength(index) === 1 || this.checkCategoryItemsLength(index) === 0) {
        this.firstResourceCategory = "";
      }
    },

    cloneResource(resource) {
      let cloneResource = JSON.parse(JSON.stringify(resource));
      if (cloneResource.property_category_name === "careers" || cloneResource.property_category_name === "educations") {
        cloneResource.name = cloneResource.property_category_name + "." + cloneResource.name;
      }

      cloneResource.itemResourceDeleted = false;
      return cloneResource;
    },

    checkEmptyResourceCategory(name) {
      let count = 0;
      this.computedResourceFields.forEach(resource => {
        if (!resource.isUsed && resource.property_category_name === name) {
          count++;
        }
      })

      return count !== 0;
    },

    updateCategory() {
      this.$emit("categoriesWasEdited", this.categories);
    },

    closeAllModal() {
      this.isVisibleModalCategory = false;
      this.isVisibleEditModalCategories.fill(false);
      this.isVisibleEditModalCategories = JSON.parse(JSON.stringify(this.isVisibleEditModalCategories));
      this.isVisibleModalConfirmDelete = false;
      this.isVisibleModalItems.forEach((modal, index) => {
        if (modal) {
          modal.status = false;
          modal.subModal.fill(false);
        } else {
          this.isVisibleModalItems[index] = {
            status: false,
            subModal: []
          }
        }
      });
      this.isVisibleModalItems = JSON.parse(JSON.stringify(this.isVisibleModalItems));
      this.isVisibleModalConfirmDeleteItem = false;
      this.refreshItem();
    }
  }
};
</script>

<style scoped>
a:hover {
  color: #db8f57;
  text-decoration: unset;
  cursor: pointer;
}

.evt-click {
  text-decoration: none;
  color: #000;
  font-size: 17px;
}

.setting_options_search_customize {
  top: 42px !important;
}

.setting_options_search {
  height: 43px !important;
}

.setting_content_sub {
  padding-top: 85px !important;
}

.item_required {
  background-color: #f16a6a !important;
}
.setting_options_wrapper{
  border-bottom: 1px solid #ddd;
}

.setting_word_break {
  word-break: break-all;
}
</style>
